export type LydbokTjeneste = {
  id: string;
  spillNavn: string;
  arketype: string;
  signaturSjangre: string[];
  forhandlingsTone: string[];
};

export const LYDBOK_TJENESTER: ReadonlyArray<LydbokTjeneste> = [
  {
    id: 'storyspill',
    spillNavn: 'Storyspill',
    arketype: 'Premium kuratert, lytter-snobber',
    signaturSjangre: ['LITERARY', 'NONFICTION', 'POETRY'],
    forhandlingsTone: [
      '«Vi velger med omhu — det merkes på listene våre.»',
      '«Lytterne våre forventer noe ekstra. Vi tror denne leverer.»',
      '«Vi ser etter litterært tyngdepunkt, og dette har det.»',
    ],
  },
  {
    id: 'lyttbokplus',
    spillNavn: 'Lyttbok+',
    arketype: 'Massemarked, alle sjangre, volum-fokus',
    signaturSjangre: ['KRIM', 'ROMANCE', 'FEELGOOD', 'FANTASY'],
    forhandlingsTone: [
      '«Vi har 800 000 lyttere — vi vet hva som funker.»',
      '«Denne passer rett inn i top-100-listen vår.»',
      '«Vi kan kjøre den hardt i appen vår fra dag én.»',
    ],
  },
  {
    id: 'bokpaaoeret',
    spillNavn: 'Bok-på-Øret',
    arketype: 'Spesialinteresser, lyrikk og essay',
    signaturSjangre: ['POETRY', 'NONFICTION', 'LITERARY'],
    forhandlingsTone: [
      '«Vi har lytterne som faktisk hører hele veien gjennom.»',
      '«Det er ingen som leser dette opp bedre enn oss.»',
      '«Vi tar oss tid til verkene — ingen industriell oppleser.»',
    ],
  },
];

export function finnLydbokTjeneste(id: string): LydbokTjeneste | undefined {
  return LYDBOK_TJENESTER.find((t) => t.id === id);
}

export function velgLydbokTjeneste(
  sjanger: string,
  rng: () => number,
): LydbokTjeneste {
  const norm = sjanger.trim().toUpperCase();
  const matchende = LYDBOK_TJENESTER.filter((t) => t.signaturSjangre.includes(norm));
  const pool = matchende.length > 0 ? matchende : LYDBOK_TJENESTER;
  const idx = Math.floor(rng() * pool.length);
  return pool[Math.min(pool.length - 1, idx)];
}

export function velgForhandlingsTone(
  tjeneste: LydbokTjeneste,
  rng: () => number,
): string {
  if (tjeneste.forhandlingsTone.length === 0) return '';
  const idx = Math.floor(rng() * tjeneste.forhandlingsTone.length);
  return tjeneste.forhandlingsTone[Math.min(tjeneste.forhandlingsTone.length - 1, idx)];
}
